import * as _ from 'lodash'
import React, { Fragment, useCallback, useEffect } from 'react';
import * as actions from '../actions';
import util from '../util';
import * as contractorActions from '../contractorActions';
import enums from '../enum';
import componentServices from '../componentServices';

import { Expander, sortableComponent } from './sharedComponents';
import ContactList from './contactList';
import ContractorEdit from './contractorEdit';
import ContractorEditOverview from './contractorEditOverview';
import ContractorEditFiles from './contractorEditFiles';
import ContractorTemplateList from './contractorTemplateList';
import ContractorContactEdit from './contractorContactEdit';
import ContractorUpgrades from './contractorUpgrades';
import JobCostEdit from './jobCostEdit';
import { getCollection, getModel, ModelCollection } from 'Scripts/store';

const ContractorTable = sortableComponent(({ updateSort, sortKey, list, ...childProps }) => {
	return (
		<table className="sortable interactive" cellPadding="0" cellSpacing="0">
			<ContractorTableHeader updateSort={updateSort} sortKey={sortKey} {...childProps} />
			<ContractorTableBody contractorCursor={list} {...childProps} />
		</table>
	);
});

class ContractorTableHeader extends React.Component<any,any> {
	handleClick (k, e) {
		e.preventDefault();
		this.props.updateSort(k);
	}
	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}
	render () {
		return (
			<thead>
				<tr>
					<td />
					<td className={this.getClassName('name')} onClick={this.handleClick.bind(this, 'name')}>Name</td>
					<td className={this.getClassName('workPhoneNumber')} onClick={this.handleClick.bind(this, 'workPhoneNumber')}>Main Office Phone</td>
					<td className={this.getClassName('accountingId')} onClick={this.handleClick.bind(this, 'accountingId')}>Accounting ID</td>
					<td />
					<td />
				</tr>
			</thead>
		);
	}
}

const ContractorTableBody = ({ contractorCursor, ...childProps }) => {
	const rows:JSX.Element[] = [];
	if (contractorCursor) {
		contractorCursor.forEach((contractor) => {
			rows.push(<ContractorTableRow contractor={ contractor } key={contractor.key} {...childProps} />);
		});
	}
	return (<tbody>{rows}</tbody>);
};

class ContractorTableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick () {
		const { contractor, moduleKey } = this.props;

		componentServices.router.pushHistory(`/${moduleKey}/contractors/${contractor.key}`);
	}
	render () {
		const { contractor } = this.props;

		return (
			<tr onClick={ this.handleClick} >
				<td />
				<td className={ contractor.currentStatus === 'locked' ? 'locked' : '' }>{ contractor.name }</td>
				<td>{ contractor.workPhoneNumber }</td>
				<td>{ contractor.accountingId }</td>
				<td />
				<td />
			</tr>
		);
	}
}

const ContractorHeading = () => {
	const contractorKey = componentServices.routeParams.contractorkey;
	const jobCostKey = componentServices.routeParams.jobcostkey;
	const { store } = componentServices;
	const contractor = contractorKey && getModel({ store, collection: ModelCollection.contractors, key: contractorKey});
	const jobCost = jobCostKey && getModel({ store, collection: ModelCollection.jobCosts, key: jobCostKey });
	const templateContent = jobCost ? <span>{ jobCost.name }</span> : null;

	return contractor ? <h1>{`${contractor.name}${templateContent ? ' • ' : ''}`}{ templateContent }</h1> : null;
};

componentServices.router.addRoutes([{
	path: '/:modulekey/contractors/:contractorkey/overview',
	component: ({ ...props }) => <ContractorEdit key={ componentServices.routeParams.contractorkey } {...props}><ContractorEditOverview /></ContractorEdit>,
	heading: <ContractorHeading />,
	contentClass: 'jobDetail',
	onEnter: componentServices.router.requireUser(({ securityContext, next }) => securityContext.currentUserHasFeature(next.params.modulekey, 'contractor-basic'), next => `/${next.params.modulekey}`)
}, {
	path: '/:modulekey/contractors/:contractorkey/template',
	component: ({ ...props }) => <ContractorEdit key={ componentServices.routeParams.contractorkey } {...props}><ContractorTemplateList /></ContractorEdit>,
	heading: <ContractorHeading />,
	contentClass: 'jobDetail',
	onEnter: componentServices.router.requireUser(({ securityContext, next }) => securityContext.currentUserHasFeature(next.params.modulekey, 'contractor-templates'), next => `/${next.params.modulekey}`)
}, {
	path: '/:modulekey/contractors/:contractorkey/client-upgrade',
	component: ({ ...props }) => <ContractorEdit key={ componentServices.routeParams.contractorkey } {...props}><ContractorUpgrades upgradeType={ enums.contractorUpgradeTypes.Client } /></ContractorEdit>,
	heading: <ContractorHeading />,
	contentClass: 'jobDetail',
	onEnter: componentServices.router.requireUser(({ securityContext, next }) => securityContext.currentUserHasFeature(next.params.modulekey, 'contractor-basic'), next => `/${next.params.modulekey}`)
}, {
	path: '/:modulekey/contractors/:contractorkey/builder-upgrade',
	component: ({ ...props }) => <ContractorEdit key={ componentServices.routeParams.contractorkey } {...props}><ContractorUpgrades upgradeType={ enums.contractorUpgradeTypes.Builder } /></ContractorEdit>,
	heading: <ContractorHeading />,
	contentClass: 'jobDetail',
	onEnter: componentServices.router.requireUser(({ securityContext, next }) => securityContext.currentUserHasFeature(next.params.modulekey, 'contractor-basic'), next => `/${next.params.modulekey}`)
}, {
	path: '/:modulekey/contractors/:contractorkey/contact',
	component: ({ ...props }) => <ContractorEdit key={ componentServices.routeParams.contractorkey } {...props}><ContactList /></ContractorEdit>,
	heading: <ContractorHeading />,
	contentClass: 'jobDetail',
	onEnter: componentServices.router.requireUser(({ securityContext, next }) => securityContext.currentUserHasFeature(next.params.modulekey, 'contractor-basic'), next => `/${next.params.modulekey}`)
}, {
	path: '/:modulekey/contractors/:contractorkey/contact/:contactkey',
	component: ({ ...props }) => <ContractorEdit key={ componentServices.routeParams.contractorkey } {...props}><ContractorContactEdit key={ componentServices.routeParams.contactkey } /></ContractorEdit>,
	heading: <ContractorHeading />,
	contentClass: 'jobDetail',
	onEnter: componentServices.router.requireUser(({ securityContext, next }) => securityContext.currentUserHasFeature(next.params.modulekey, 'contractor-basic'), next => `/${next.params.modulekey}`)
}, {
	path: '/:modulekey/contractors/:contractorkey/template/:jobcostkey/:viewkey?',
	component: ({ ...props }) => <ContractorEdit key={ componentServices.routeParams.contractorkey } {...props}><JobCostEdit key={ componentServices.routeParams.jobcostkey } /></ContractorEdit>,
	heading: <ContractorHeading />,
	contentClass: 'jobDetail',
	onEnter: ({ next, replace }) => {
		const accessTest = componentServices.router.requireUser(({ securityContext }) => securityContext.currentUserHasFeature(next.params.modulekey, 'contractor-templates'));
		if (accessTest({ next: next, replace: replace }) !== false && !next.params.viewkey) {
			replace(next.location.pathname + '/setup');
			return false; // be sure not to render this route
		}
	}
}, {
	path: '/:modulekey/contractors/:contractorkey/files',
	component: ({ ...props }) => <ContractorEdit key={ componentServices.routeParams.contractorkey } {...props}><ContractorEditFiles emptyTitle = "No Files" /></ContractorEdit>,
	heading: <ContractorHeading />,
	contentClass: 'jobDetail',
	onEnter: componentServices.router.requireUser(({ securityContext, next }) => securityContext.currentUserHasFeature(next.params.modulekey, 'contractor-basic'), next => `/${next.params.modulekey}`)
}, {
	path: '/:modulekey/contractors/:contractorkey',
	onEnter: ({ next, replace }) => {
		replace(`/${next.params.modulekey}/contractors/${next.params.contractorkey}/overview`);
		// cancel the route transition
		return false;
	}
}]);

export default function ContractorList({ moduleKey, types}: { moduleKey: string, types: number[]}) {

	const handleAddContractorClick = useCallback(e => {
		e.preventDefault();

		componentServices.router.pushHistory(`/${moduleKey}/contractors/${util.generateGuid()}`);
	}, []);

	useEffect(() => {
		actions.setHeaderAction({
			key: 'contractor-add-action',
			element: <button className="icon addBuilder" onClick={handleAddContractorClick}><span /></button>
		});

		let queryType = 0;
		_.forEach(types, t => {
			queryType |= t;
		});

		contractorActions.fetchContractors({ filters: { type: queryType } });

		return () => {
			actions.deleteHeaderAction({ key: 'contractor-add-action' });
		}
	}, []);

	const { store } = componentServices;
	const sections = _.map(types, t => {
		const sectionList = getCollection({ store, collection: ModelCollection.contractors}).filter(c => (c.type & t) !== 0).sortBy(c => c.name);
		const sectionCount = sectionList.count();
		const title = `${enums.contractorTypes.getDisplayName(t)}s`;

		return (!sectionCount) ? null : (
			<Expander title={ title} isExpanded={ !!sectionCount } key={ t }>
				<ContractorTable list={sectionList} initialSortKey="name" moduleKey={ moduleKey } allowedTypes={ types } />
			</Expander>
		);
	});

	return (
		<Fragment>
			{ sections }
		</Fragment>
	);
}
// export default class ContractorList extends React.Component<any,any> {
// 	componentDidMount () {
// 		actions.setHeaderAction({
// 			key: 'contractor-add-action',
// 			element: <button className="icon addBuilder" onClick={this.handleAddContractorClick.bind(this)}><span /></button>
// 		});

// 		const { types } = this.props;
// 		let queryType = 0;
// 		_.forEach(types, t => {
// 			queryType |= t;
// 		});

// 		contractorActions.fetchContractors({ type: queryType });
// 	}
// 	componentWillUnmount () {
// 		actions.deleteHeaderAction({ key: 'contractor-add-action' });
// 	}
// 	handleAddContractorClick (e) {
// 		e.preventDefault();

// 		const { moduleKey } = this.props;

// 		componentServices.router.pushHistory(`/${moduleKey}/contractors/${util.generateGuid()}`);
// 	}
// 	render () {
// 		const { moduleKey, types } = this.props;
// 		const { store } = componentServices;

// 		const sections = _.map(types, t => {
// 			const sectionList = getCollection({ store, collection: ModelCollection.contractors}).filter(c => (c.type & t) !== 0).sortBy(c => c.name);
// 			const sectionCount = sectionList.count();
// 			const title = `${enums.contractorTypes.getDisplayName(t)}s`;

// 			return (!sectionCount) ? null : (
// 				<Expander title={ title} isExpanded={ !!sectionCount } key={ t }>
// 					<ContractorTable list={sectionList} initialSortKey="name" moduleKey={ moduleKey } allowedTypes={ types } />
// 				</Expander>
// 			);
// 		});

// 		return (
// 			<Fragment>
// 				{ sections }
// 			</Fragment>
// 		);
// 	}
// }
